<ng-template #full>
  <div class="b-sidebar-section__title" *ngIf="title && !showInTab" (click)="toggle()">
    <span class="b-icon"
    [class.b-icon--hinge-fold-out]="!isCollapsed"
    [class.b-icon--hinge]="isCollapsed"
    >{{isCollapsed ? 'chevron_right' : 'expand_more'}}</span>
    <span [innerHTML]="titleAsync | async"></span>
  </div>
  <div class="b-sidebar-section__content">
    <div class="b-sidebar-section__content-wrapper" *ngIf="!isCollapsed">
      <w-inline-filter *ngIf="hasFilter" [placeholder]="(filterPlaceholderAsync | async) ?? 'Search'" [(ngModel)]="filterText" (wChange)="wChange.emit($event)" ></w-inline-filter>
      <ng-content></ng-content>
    </div>
  </div>
</ng-template>
<ng-template #short>
  <w-field style="margin-left: 1.25em;" [label]="(titleAsync | async) +':'" >{{labelAsync | async}}</w-field>  
</ng-template>
<ng-template #none></ng-template>
<ng-container *ngTemplateOutlet="hiddenTab ? none : (!!label ? short : full)"></ng-container>

